module.exports = __webpack_public_path__ + "assets/img/34t.c8df37e4.png";